import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getVariationDraft } from "@src/store/slices/experienceBuilder/common/selectors/getVariationDraft";
import { cancelDraft } from "@src/store/slices/experienceBuilder/common/thunks/cancelDraft";
import { initDraft } from "@src/store/slices/experienceBuilder/common/thunks/initDraft";
import { trackGroupToggled } from "@src/store/slices/experienceBuilder/common/thunks/mixPanel";
import { isEquivalent } from "@src/store/slices/experienceBuilder/common/utils/modHandlerRegistry";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

export const switchVariationId = createAsyncThunk<void, string>(
  "experienceBuilder/switchVariationId",
  async (newVariationId, { dispatch, getState }) => {
    const draftMod = getVariationDraft(getState());

    // If not editing a mod, just switch normally
    if (!draftMod) {
      void dispatch(trackGroupToggled({ variationId: newVariationId }));
      dispatch(experienceBuilderSlice.actions.setVariationId(newVariationId));
      return;
    }

    // Preserve current tab state for injection mods
    const currentTab = draftMod.type === "injection" ? draftMod.tab : undefined;

    // Check for unsaved changes and prompt to discard if needed
    const confirmed = await dispatch(cancelDraft()).unwrap();
    if (!confirmed) {
      return;
    }

    // Track successful switch
    void dispatch(trackGroupToggled({ variationId: newVariationId }));

    // Switch variation
    dispatch(experienceBuilderSlice.actions.setVariationId(newVariationId));

    // Find matching mod in new variation
    const mods = getState().experienceBuilder.mods;
    const matchingMod = mods.find(
      (m) => m.variationId === newVariationId && isEquivalent(draftMod, m)
    );

    // If matching mod found, open it (preserving tab state for injections)
    if (matchingMod) {
      if (matchingMod.type === "injection" && currentTab) {
        void dispatch(initDraft({ ...matchingMod, tab: currentTab }));
      } else {
        void dispatch(initDraft(matchingMod));
      }
    }
    // Otherwise, cancelDraft already cleared the draft, returning to modifications list
  }
);
